import IsServerSideRendering from './IsServerSideRendering';

const purchaseProcessRegex = /^(\/acquisition|\/procurement|\/purchase).*/;

const IsPurchaseProcess = () => {
  if (IsServerSideRendering) return null;

  const urlPath = window.location.pathname;
  return urlPath.match(purchaseProcessRegex);
};

export default IsPurchaseProcess;
